import { HTMLAttributes } from 'react';

import { activeDot, dotsWrapper } from './dots.module.scss';

export interface DotsScrollCard {
    name: string;
    [key: string]: any;
}

interface DotsProps extends HTMLAttributes<HTMLDivElement> {
    cards: DotsScrollCard[];
    activeIndex: number;
    handleDotClick?: (index: number) => void;
}

export const Dots = ({ cards, activeIndex, handleDotClick, className, ...rest }: DotsProps) => {
    const handleClick = (index: number) => {
        if (handleDotClick) {
            handleDotClick(index);
        }
    };

    return (
        <div className={`${dotsWrapper} ${className}`} {...rest}>
            {cards.map((card, index) => (
                <button
                    key={card.name}
                    id={card.name}
                    className={activeIndex === index ? activeDot : ''}
                    onClick={() => handleClick(index)}></button>
            ))}
        </div>
    );
};
